import { http } from 'utils'

import { creditAllocationTxServiceTypes } from 'types/creditAllocationTxTypes'
import { creditAllocationRefundTxServiceTypes } from 'types/creditAllocationRefundTxTypes'

export async function creditAllocationAPI({
  creditValue,
  externalTransactionId,
  ident,
  cashier,
  guid,
  transactionDate,
  storeId,
  comments,
  traceNumber,
  reasonId,
  pin,
}: creditAllocationTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/credit-allocation'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    cashier,
    guid,
    transactionDate,
    storeId,
    comments,
    traceNumber,
    reasonId,
    pin,
  }
  return await http.post(url, data)
}

export async function creditAllocationRefundAPI({
  creditValue,
  externalTransactionId,
  ident,
  cashier,
  guid,
  transactionDate,
  comments,
  traceNumber,
  reasonId,
  pin,
}: creditAllocationRefundTxServiceTypes): Promise<void> {
  const url = '/manual-transaction/credit-allocation-refund'
  const data = {
    creditValue,
    externalTransactionId,
    ident,
    cashier,
    guid,
    transactionDate,
    comments,
    traceNumber,
    reasonId,
    pin,
  }
  return await http.post(url, data)
}